/* eslint-disable import/no-anonymous-default-export */
import mergeOperations from "@/util/shallowMerge"
import {
  useMutation
} from "@apollo/client"
import {
  useCallback, useMemo, useRef, useState
} from "react"
import DEFAULT_OPERATIONS from "./claimWarrantyPage.gql"

export default (props) => {
  const {
    afterSubmit 
  } = props
  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations)

  const {
    addClaimWarrantyMutation 
  } = operations

  const formApiRef = useRef(null)

  const [isLoading, setIsLoading] = useState(false)

  const [addClaimWarranty, {
    data, error: addClaimWarrantyError 
  }] =
        useMutation(addClaimWarrantyMutation, {
          fetchPolicy: "no-cache",
        })

  const handleSubmit = useCallback(
    async (values) => {
      const {
        email, number, firstName: firstname, lastName: lastname, description: issues, images 
      } = values

      setIsLoading(true)

      try {
        await addClaimWarranty({
          variables: {
            email,
            number,
            firstname,
            lastname,
            issues,
            imgs: images
          },
        })

        formApiRef.current?.reset()

        if (afterSubmit) {
          afterSubmit()
        }
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error(error)
        }
      } finally {
        setIsLoading(false)
      }
    },
    [addClaimWarranty, afterSubmit]
  )

  const errors = useMemo(
    () => new Map([["addClaimWarrantyError", addClaimWarrantyError]]),
    [addClaimWarrantyError]
  )

  return {
    formApiRef,
    isBusy: isLoading,
    isLoading,
    errors,
    handleSubmit,
    response: data && data.addClaimWarranty,
  }
}
